import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';

const StatusWrapper = styled.div`
  ${props =>
    props.busy &&
    css`
      opacity: 0.3;
    `};
  transition: opacity 0.15s ease-in-out;
`;

StatusWrapper.propTypes = {
  busy: PropTypes.bool.isRequired
};

export default StatusWrapper;



// WEBPACK FOOTER //
// ./src/components/StatusWrapper.js